import * as DTO from '@rw1/auto-generated-clients/generated/user-generated-content/dto.generated'
import * as Models from '@rw1/models'
import { injectable } from 'inversify'
import { IUserGeneratedContentMapper } from './IUserGeneratedContentMapper'

@injectable()
export class UserGeneratedContentMapper implements IUserGeneratedContentMapper {
    toUserFileModel(dto: DTO.UserFileData): Models.UserFile {
        return {
            userFileId: dto.userFileId,
            convertedFileName: dto.convertedFileName,
            originalFile: dto.originalFile,
            created: dto.created,
            fileType: this.toFileTypeModel(dto.fileType),
            fileVersions: dto.fileVersions,
            status: this.toFileConversionStatusModel(dto.status),
            isAvailable: false,
            hasMissingVersions: false
        }

    }

    toFileConversionStatusModel(dto: DTO.FileConversionStatus): Models.FileConversionStatus {
        switch (dto) {
            case DTO.FileConversionStatus.Converted:
                return Models.FileConversionStatus.Converted
            case DTO.FileConversionStatus.Processing:
                return Models.FileConversionStatus.Processing
            case DTO.FileConversionStatus.PartiallyConverted:
                return Models.FileConversionStatus.PartiallyConverted
            case DTO.FileConversionStatus.Failed:
                return Models.FileConversionStatus.Failed
            default:
                throw new Error("Invalid conversion status")
        }
    }

    toFileTypeModel(dto: DTO.StorageType): Models.FileType {
        switch (dto) {
            case DTO.StorageType.Company:
                return Models.FileType.Company
            case DTO.StorageType.Personal:
                return Models.FileType.Personal
            case DTO.StorageType.Sample:
                return Models.FileType.Sample
            default:
                throw new Error("Invalid file type")
        }
    }

    toStorageTypeDto(model: Models.FileType): DTO.StorageType {
        switch (model) {
            case Models.FileType.Company:
                return DTO.StorageType.Company
            case Models.FileType.Personal:
                return DTO.StorageType.Personal
            case Models.FileType.Sample:
                return DTO.StorageType.Sample
            default:
                throw new Error("Invalid file type")
        }
    }
}
